<section class="public-section article-grid-page">
  <header class="public-page-header">
    <h2 class="public-page-title">Resultado da pesquisa</h2>
    <p class="public-page-subtitle">Termo pesquisado: <b>{{termoPesquisa}}</b></p>
    @if (materias) {
      <p class="public-page-subtitle">Encontrado <b>{{materias.length}}</b> artigos</p>
    }
  </header>

  <div class="row masonry-grid" #masonryGrid>
    <div class="grid-sizer"></div>
    @for (materia of materias; track materia; let index = $index) {
      <div class="grid-item mb-4">
        <div class="card">
          <img src="./imagens/{{materia.data | date: 'yyyyMMdd'}}/{{materia.imagemDestaque}}" class="card-img-top"
            (error)="handleMissingImage($event)" (load)="onImageLoad()" />
          <div class="card-body">
            <h4 class="card-title">{{materia.titulo}}</h4>
            <p class="card-text">
              <small class="text-muted">{{materia.data | date: 'dd/MM/yyyy'}} - {{materia.tema.nome}}</small>
            </p>
            <p class="card-text" [innerHtml]="materia.resumo"></p>
            <div class="mt-auto">
              <a href="materia/{{materia.id}}" class="stretched-link">Continue a ler</a>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</section>